export default {"src":"/_next/static/media/cart-icon.d60aede5.svg","height":25,"width":26,"blurWidth":0,"blurHeight":0};